export const HomeFaqList = [
  {
    id: 0,
    title: 'What is Shariah-compliant banking?',
    content: `
    <p>Shariah-compliant banking refers to financial products and services structured in accordance with Islamic principles. This includes:</p>
      <ul>
      <li><p className="mb-0">Avoiding interest (Riba)</p></li>
      <li><p className="mb-0">Prohibiting excessive uncertainty in contracts and excluding activities involving gambling or speculation.</p></li>
      <li><p className="mb-0">Ensuring all financing is supported by genuine underlying assets or business activities to fairly share risk and reward.</p></li>
      </ul>
      <p>One commonly used tenure is tawarruq (commodity murabahah), which provides financing to a customer through a series of structured commodity sales. Tawarruq is applied in selected Islamic financing products such as <a href="/personal/financing/home-financing-i-sjkp/">Home Financing i-SJKP</a> and <a href="/personal/deposits/term-deposit-i/">Commodity Murabahah Term Deposit-i</a>.</p>`
  },
  {
    id: 1,
    title: 'Is alrajhi bank Malaysia a full-fledged Islamic bank? ',
    content:
      '<p>Yes. alrajhi bank Malaysia operates in accordance with Islamic finance principles, where financing structures are based on Shariah-approved contracts rather than conventional interest-based lending. Financing and investment structures are based on approved Shariah contracts such as murabahah and wakalah and are linked to genuine underlying assets or business activities.</p>'
  },
  {
    id: 2,
    title: 'Is Islamic banking only for Muslims?',
    content:
      '<p>No. Islamic banking is available to everyone, regardless of religion. In Malaysia, many customers choose Islamic banking because of its transparent structure, clear terms, and ethical financial approach. Islamic banks provide the same everyday banking services as conventional banks do, such as savings accounts, real-time payments/transfers, and online banking, while adhering to Shariah-compliant principles.</p>'
  },
  {
    id: 3,
    title: 'Does alrajhi bank Malaysia offer corporate or business financing?',
    content:
      '<p>Yes, alrajhi bank Malaysia provides Shariah-compliant corporate financing solutions including <a href="/business/financing/structured-commodity-financing-i/">corporate financing</a>, <a href="/business/cash-management/alrajhi-cashbiz/">cash management</a>, and <a href="/business/treasury/deposit/">deposit accounts</a>.</p>'
  },
  {
    id: 4,
    title: 'How is Shariah integrity maintained within alrajhi bank Malaysia?',
    content:
      "<p>Shariah integrity in alrajhi bank Malaysia is upheld through a robust governance framework overseen by our Shariah Board, which provides independent oversight and approval for all offerings. This is supported by our internal Shariah teams, who ensure end-to-end compliance through continuous monitoring and Shariah reviews of all materials and processes. This multi-layered approach ensures every transaction aligns with the standards of the <a href='https://www.bnm.gov.my/committees/sac-old' target='_blank' rel='noopener noreferrer'>Shariah Advisory Council of Bank Negara Malaysia</a>.</p>"
  }
]

export const FaqList = [
  {
    id: 0,
    title: 'What is the Shariah contract applicable?',
    content: 'The applicable Shariah contract is Commodity Murabahah.'
  },
  {
    id: 1,
    title: 'What is the minimum and maximum tenure?',
    content:
      'The financing tenure is ranging from minimum 1 year up to 8 years, subject to terms and conditions.'
  },
  {
    id: 2,
    title: 'What is the minimum and maximum financing amount?',
    content:
      'Minimum financing amount is RM10,000 and maximum financing amount is RM50,000, subject to terms and conditions.'
  },
  {
    id: 3,
    title: 'Is takaful / insurance coverage compulsory?',
    content: 'The takaful / insurance coverage is optional.'
  },
  {
    id: 4,
    title:
      "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at <a href='tel:+60323326000'>+603-2332 6000</a>, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry' target='_blank' rel='noopener noreferrer'>Product Enquiry</a> , our bank representative will contact to assist you.</p>"
  },
  {
    id: 5,
    title: 'How do I pay for the monthly installment?',
    content:
      'You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.'
  },
  {
    id: 6,
    title: 'What if I fully settle the financing before its maturity?',
    content:
      '<p>You may opt to fully settle the financing prior to the maturity date. Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p>'
  },
  {
    id: 7,
    title: 'How do I contact alrajhi bank Malaysia?',
    content:
      '<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p><a href="tel:+60323326000">+603-2332 6000</a></p><p>customersupport@alrajhibank.com.my</p>'
  }
]

export const FaqListHighIncome = [
  {
    id: 0,
    title: 'What is the Shariah contract applicable?',
    content: 'The applicable Shariah contract is Commodity Murabahah.'
  },
  {
    id: 1,
    title: 'What is the minimum and maximum tenure?',
    content:
      'The financing tenure is ranging from minimum 1 year up to 8 years, subject to terms and conditions.'
  },
  {
    id: 2,
    title: 'What is the minimum and maximum financing amount?',
    content:
      'Minimum financing amount is RM1,000 and maximum financing amount is RM250,000, subject to terms and conditions.'
  },
  {
    id: 3,
    title: 'Is takaful / insurance coverage compulsory?',
    content: 'The takaful / insurance coverage is optional.'
  },
  {
    id: 4,
    title:
      "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at <a href='tel:+60323326000'>+603-2332 6000</a>, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry' target='_blank' rel='noopener noreferrer'>Product Enquiry</a> , our bank representative will contact to assist you.</p>"
  },
  {
    id: 5,
    title: 'How do I pay for the monthly installment?',
    content:
      'You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.'
  },
  {
    id: 6,
    title: 'What if I fully settle the financing before its maturity?',
    content:
      '<p>You may opt to fully settle the financing prior to the maturity date. Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p>'
  },
  {
    id: 7,
    title: 'How do I contact alrajhi bank Malaysia?',
    content:
      '<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p><a href="tel:+60323326000">+603-2332 6000</a></p><p>customersupport@alrajhibank.com.my</p>'
  }
]

export const FaqListUmrah = [
  {
    id: 0,
    title: 'Apakah kontrak Syariah yang digunakan?',
    content: 'Kontrak Syariah yang berkenaan ialah Komoditi Murabahah.'
  },
  {
    id: 1,
    title: 'Apakah tempoh pembiayaan minimum dan maksimum?',
    content:
      'Tempoh pembiayaan minimum ialah 1 tahun, dan tempoh pembiayaan maksimum ialah 8 tahun, tertakluk kepada terma dan syarat.'
  },
  {
    id: 2,
    title: 'Apakah jumlah pembiayaan minimum dan maksimum?',
    content:
      'Jumlah pembiayaan minimum ialah RM10,000 dan jumlah pembiayaan maksimum ialah RM50,000, tertakluk kepada terma dan syarat.'
  },
  {
    id: 3,
    title: 'Adakah perlindungan takaful / insurans wajib?',
    content: 'Perlindungan takaful / insurans tidak diwajibkan.'
  },
  {
    id: 4,
    title:
      "<span>Bagaimana memohon Pembiayaan <span className='no-wrap'>Peribadi-<i>i</i> ?</span></span>",
    content:
      "<p>Anda boleh datang terus ke cawangan terdekat, atau hubungi talian perkhidmatan pelanggan kami di <a href='tel:+60323326000'>+603-2332 6000</a> atau tinggalkan butiran hubungan anda dalam pautan <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>ini</a>, wakil bank kami akan menghubungi untuk membantu anda.</p>"
  },
  {
    id: 5,
    title: 'Bagaimana bayar ansuran bulanan?',
    content:
      'Anda dikehendaki mendepositkan ansuran bulanan dalam akaun pembiayaan pada atau sebelum tarikh ansuran matang sehingga penyelesaian penuh pembiayaan.'
  },
  {
    id: 6,
    title: 'Bagaimana jika saya menjelaskan sepenuhnya pembiayaan sebelum akhir tempoh pembiayaan?',
    content:
      'Anda boleh membuat penjelasan awal pada bila-bila masa dalam tempoh pembiayaan. Rebat atau Ibra’ akan diberikan sejajar dengan garis panduan Bank Negara Malaysia dan garis panduan Bank.'
  },
  {
    id: 7,
    title: 'Bagaimana saya boleh menghubungi alrajhi bank Malaysia?',
    content:
      'Untuk maklumat lanjut, sila hubungi Perunding Khidmat Pelanggan 24 Jam kami di <a href="tel:+60323326000">+603-2332 6000</a>, atau emel ke customersupport@alrajhibank.com.my.'
  }
]
export const FaqListUmrahHighIncome = [
  {
    id: 0,
    title: 'Apakah kontrak Syariah yang digunakan?',
    content: 'Kontrak Syariah yang berkenaan ialah Komoditi Murabahah.'
  },
  {
    id: 1,
    title: 'Apakah tempoh pembiayaan minimum dan maksimum?',
    content:
      'Tempoh pembiayaan minimum ialah 2 tahun, dan tempoh pembiayaan maksimum ialah 8 tahun, tertakluk kepada terma dan syarat.'
  },
  {
    id: 2,
    title: 'Apakah jumlah pembiayaan minimum dan maksimum?',
    content:
      'Jumlah pembiayaan minimum ialah RM1,000 dan jumlah pembiayaan maksimum ialah RM250,000, tertakluk kepada terma dan syarat.'
  },
  {
    id: 3,
    title: 'Adakah perlindungan takaful / insurans wajib?',
    content: 'Perlindungan takaful / insurans tidak diwajibkan.'
  },
  {
    id: 4,
    title:
      "<span>Bagaimana memohon Pembiayaan <span className='no-wrap'>Peribadi-<i>i</i> ?</span></span>",
    content:
      "<p>Anda boleh datang terus ke cawangan terdekat, atau hubungi talian perkhidmatan pelanggan kami di <a href='tel:+60323326000'>+603-2332 6000</a> atau tinggalkan butiran hubungan anda dalam pautan <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>ini</a>, wakil bank kami akan menghubungi untuk membantu anda.</p>"
  },
  {
    id: 5,
    title: 'Bagaimana bayar ansuran bulanan?',
    content:
      'Anda dikehendaki mendepositkan ansuran bulanan dalam akaun pembiayaan pada atau sebelum tarikh ansuran matang sehingga penyelesaian penuh pembiayaan.'
  },
  {
    id: 6,
    title: 'Bagaimana jika saya menjelaskan sepenuhnya pembiayaan sebelum akhir tempoh pembiayaan?',
    content:
      'Anda boleh membuat penjelasan awal pada bila-bila masa dalam tempoh pembiayaan. Rebat atau Ibra’ akan diberikan sejajar dengan garis panduan Bank Negara Malaysia dan garis panduan Bank.'
  },
  {
    id: 7,
    title: 'Bagaimana saya boleh menghubungi alrajhi bank Malaysia?',
    content:
      'Untuk maklumat lanjut, sila hubungi Perunding Khidmat Pelanggan 24 Jam kami di <a href="tel:+60323326000">+603-2332 6000</a>, atau emel ke customersupport@alrajhibank.com.my.'
  }
]

// FAQs for e-Invoicing

export const FAQ_e_Invoicing = [
  {
    id: 1,
    title: 'What is an e-Invoice?',
    content: `Think of an e-Invoice as a digital version of your usual paper invoices, credit notes, or debit notes. It’s simply a digital record of a transaction between a business and a customer, designed to replace physical documents.`
  },
  {
    id: 2,
    title: 'When is the effective date?',
    content:
      'Starting 1 July 2025, alrajhi bank Malaysia will fully comply with e-Invoice requirements as outlined by Inland Revenue Board of Malaysia (IRBM) / Lembaga Hasil Dalam Negeri Malaysia (LHDNM) through Individual e-Invoice, Self-Billed e-Invoice, and Consolidated e-Invoice.'
  },
  {
    id: 3,
    title: 'Will the e-Invoice replace the existing statements provided by the Bank?',
    content:
      'The statements you currently receive from alrajhi bank Malaysia will stay the same. An e-Invoice will simply be an extra document we provide if you request it. '
  },
  {
    id: 4,
    title: 'Who will receive the e-Invoice from the Bank?',
    content: `We'll only generate an e-Invoice for you when you ask for it.`
  },

  {
    id: 5,
    title: 'How frequently will e-Invoices be issued?',
    content: 'e-Invoices will usually be issued on a monthly basis.'
  },
  {
    id: 6,
    title: 'How will i receive my e-Invoice?',
    content:
      'To make sure you get your e-Invoice smoothly, we’ll send it right to your email address. Please remember to provide a valid and active email so it reaches you without a problem.'
  },
  {
    id: 7,
    title: 'Do I need to provide any information for an e-Invoice to be issued?',
    content: `
      Yes, the following information will be required from customers who require an e-Invoice:
      <ul class="about-list"> <li>Name</li> <li>Tax Identification Number (TIN)</li> <li>Registration / Identification Number / Passport Number</li> <li>Email</li> <li>Address</li> <li>Contact Number</li> <li>SST Registration Number – only for SST registrants</li> </ul>
      Please submit this information via the <strong>E-Invoicing Request Form</strong> available at branches, or you may request it from our Customer Care team at <a href="tel:+60323326000">+603-2332 6000</a> or <a href="mailto:customersupport@alrajhibank.com.my">customersupport@alrajhibank.com.my</a>.

      `
  },
  {
    id: 8,
    title: 'Where can I obtain further information about e-Invoicing?',
    content: `
      E-Invoicing information may be obtained from Inland Revenue Board of Malaysia (IRBM) / Lembaga Hasil Dalam Negeri Malaysia (LHDNM): <a href="https://www.hasil.gov.my/en/e-invoice" target="_blank" rel="noopener noreferrer"> https://www.hasil.gov.my/en/e-invoice </a>.
      <br/><br/>
      You can also find the answers you need through any of our dedicated support channels.
      <br/><br/>
      Contact Customer Care<br/><br/>
      Our team is available 24/7 to assist you.
      <ul> <li>Call us at: <a href="tel:+60323326000">+603-2332 6000</a></li> <li>Email us at: <a href="mailto:customersupport@alrajhibank.com.my">customersupport@alrajhibank.com.my</a></li> <li>Visit us in person: Feel free to visit your nearest branch or speak directly with your Relationship Manager for personalized assistance.</li> </ul>
      `
  }
]
